<div class="new-mobile-menu flex justify-between gap-2 px-4 pb-4 pt-7">
  @for (item of items(); track item.route) {
    <a class="sidebar-link" [routerLink]="item.route" routerLinkActive="active" (click)="navigateToRoute(item.route)">
      <div class="sidebar-link-image">
        @if (state.darkMode && item.iconDark) {
          <img [src]="item.iconDark" [alt]="item.labelKey | transloco" class="mobile-menu-icon" />
        } @else {
          <img [src]="item.icon" [alt]="item.labelKey | transloco" class="mobile-menu-icon" />
        }
      </div>

      <span class="sidebar-link-text">{{ item.labelKey | transloco }}</span>
    </a>
  }

  @if (state.user) {
    <dojo-sidebar-profile-link
      [user]="state.user"
      [settingsRoute]="settingsRoute()"
      (clicked)="navigateToSettings()"
      class="sidebar-profile-link-component flex-1 truncate"
    />
  }
</div>
